import { transformDateValue } from 'core/js/FormUtils';
export const getStockorderView = (dataList) => {
  
  const transformDataValue = (value, type) =>{
    if (!type.includes('date')) return value;
    return transformDateValue(value);
  }

  let stockorderList = [];
  dataList.map((data)=>{
  let card = {
            'id': data.id,
            'headingList': [
                            {"fieldLabel":"Title","fieldValue":transformDataValue(data.title,"string"), "fieldType":"string"},
                            {"fieldLabel":"Party Id","fieldValue":transformDataValue(data.partyid,"bodynamiclist"), "fieldType":"bodynamiclist"},
                            {"fieldLabel":"Party Name","fieldValue":transformDataValue(data.partyname,"string"), "fieldType":"string"},
                            {"fieldLabel":"Order Status Id","fieldValue":transformDataValue(data.orderstatusid,"bodynamiclist"), "fieldType":"bodynamiclist"},
                            {"fieldLabel":"Order Status Name","fieldValue":transformDataValue(data.orderstatusname,"string"), "fieldType":"string"},
                            {"fieldLabel":"Remarks","fieldValue":transformDataValue(data.remarks,"string"), "fieldType":"string"},
                            {"fieldLabel":"Party Type Id","fieldValue":transformDataValue(data.partytypeid,"number"), "fieldType":"number"},
              
              
            ],
            'dataList': [
                
              ]
          }

          stockorderList.push(card);
  })
  return stockorderList;
}